/** 和跨部门有关的接口 **/
import request from '../index';
/** 
* TransDeptNotice
* @params {string} data.createTime 
* @params {string} data.fileLink 文件
* @params {number} data.id 
* @params {string} data.originalDept 原部门
* @params {string} data.translDept 跨部门
* @params {string} data.translDeptNotice 跨部门公告
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* TransDeptRequirement
* @params {string} data.completeRequirementDept 完成需求部门
* @params {string} data.deliveryDate 交付日期
* @params {string} data.deliveryFile 交付文件
* @params {string} data.demander 需求人
* @params {string} data.demanderDept 需求部门
* @params {string} data.demanderDeptHead 需求部门负责人
* @params {number} data.demanderId 
* @params {string} data.executor 执行人
* @params {number} data.executorId 
* @params {string} data.expectedDeliveryDate 期望交付日期
* @params {number} data.id 
* @params {boolean} data.isDelivery 是否交付
* @params {boolean} data.isPush 是否推送
* @params {boolean} data.isReceive 是否接收
* @params {string} data.notes 备注
* @params {string} data.progress 进度
* @params {string} data.proposedTime 提出时间
* @params {string} data.pushDate 推送日期
* @params {string} data.receiveDate 接收日期
* @params {string} data.requirementContent 需求内容
* @params {string} data.requirementDeliveryConfirmation 需求交付确认
* @params {string} data.requirementFile 需求文件
* @params {string} data.requirementName 需求名称
*/

/** 
* 删除跨部门需求
* @params {array} ids
*/
export const deleteTransDeptNotice = (data) => request.delete('/api-qc/deleteTransDeptNotice', { data });

/** 
* 删除跨部门需求
* @params {array} ids
*/
export const deleteTransDeptRequirement = (data) => request.delete('/api-qc/deleteTransDeptRequirement', { data });

/** 
* 获得跨部门公告列表
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.originalDept 原部门
* @params {number} params.pageNum 页码
* @params {string} params.translDept 跨部门
* @params {boolean} params.translDeptNotice 跨部门公告
*/
export const getTransDeptNoticeList = (params) => request.get('/api-qc/getTransDeptNoticeList', { params });

/** 
* 获得跨部门需求列表
* @params {string} params.demander 需求人
* @params {string} params.executor 执行人
* @params {string} params.firstLevelDepartment 一级部门
* @params {boolean} params.isPush 是否推送
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {string} params.requirementDeliveryConfirmation 需求交付确认
*/
export const getTransDeptRequirementList = (params) => request.get('/api-qc/getTransDeptRequirementList', { params });

/** 
* 添加or更新跨部门公告
* @params {TransDeptNotice} transDeptNotice
*/
export const saveTransDeptNotice = (data) => request.post('/api-qc/saveTransDeptNotice', data);

/** 
* 添加or更新跨部门需求
* @params {TransDeptRequirement} transDeptRequirement
*/
export const saveTransDeptRequirement = (data) => request.post('/api-qc/saveTransDeptRequirement', data);

/** 
* 上传跨部门文件
*/
export const uploadTransDeptFile = (data) => request.post('/api-qc/uploadTransDeptFile', data);

